<template>
  <!-- Start header calendar -->
  <b-col md="12" class="header_css">
    <div class="header__calendar">
      <b-row>
        <b-col md="12">
          <p class="bold c-white header__calendar-day">
            Ngày {{ date.getDate() }}
          </p>
        </b-col>
      </b-row>
    </div>
  </b-col>
  <!-- End header calendar -->
</template>
<script>
export default {
  props: { date: { type: Date }, default: new Date() }
};
</script>
<style scoped>
.header__calendar {
  width: auto;
  background: var(--orange);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 20px 20px 20px 20px;
}
.header__calendar-day {
  font-size: 45px;
  text-align: center;
  color: #fff;
  line-height: normal;
}
.header__calendar-dayweek {
  font-size: 20px;
  flex: none;
}
.underline {
  height: 5px;
  width: 85px;
  border-radius: 100px;
  position: absolute;
  top: 85px;
  left: 20px;
}
.bgc-green {
  background-color: #30da88;
}
.bgc-light-blue {
  background-color: var(--blue);
}
.bgc-orange {
  background-color: #f79d61;
}
.bgc-red {
  background-color: var(--red);
}
.c-green {
  color: #30da88;
}
.c-light-blue {
  color: var(--blue);
}
.c-orange {
  color: #f79d61;
}
.c-red {
  color: var(--red);
}
.c-white {
  color: #fff;
}
.el-calendar .el-calendar__header .el-calendar__title {
  visibility: hidden;
}
::v-deep .box-card_request .el-card__header {
  padding: 10px 20px;
}
::v-deep .box-card_request .el-card__body {
  height: calc(100vh - 459px);
  overflow: auto;
}
::v-deep .el-calendar-table td.is-selected {
  background-color: #d8ebff;
}
::v-deep .el-calendar-table td.is-today {
  color: #007dff;
  font-weight: bold;
}
.box-shadow {
  box-shadow: rgba(0, 0, 0, 0.1) -4px 9px 25px -6px;
}
@media (min-width: 1600px) {
  .title-box_card {
    font-size: 20px;
  }
  .subtitle {
    font-size: 20px;
  }
  .count {
    font-size: 64px;
  }
}
@media (max-width: 1530px) {
  .title-box_card {
    max-width: 180px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .title-box_card_popover {
    display: block;
  }
  .header__calendar {
    padding: 15px 15px 10px 15px;
  }
  .header__calendar-day {
    font-size: 35px;
  }
  .header__calendar-dayweek {
    font-size: 18px;
  }
  .header__calendar-subtitle {
    font-size: 13px;
  }
}
@media (max-width: 1199px) {
  .title-box_card {
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .icon {
    display: none;
  }
}
</style>
